import { createSelector } from '@reduxjs/toolkit';
import { BannerModalConfig, SettingKey, Setting, VolcanoBannerModalConfig } from '../../models/setting.model';
import { ContentModel } from '../../models/content.model';
import { merge } from 'lodash';
import defaultContent from 'utils/data';

const selectSettingsState = (state: any) => state.setting;

const SETTINGS_MANAGED_ON_DEDICATED_PAGES = new Set<string>([
  SettingKey.PAGE_CONTENT,
  SettingKey.BANNER_MODAL_CONFIG,
  SettingKey.VOLCANO_BANNER_MODAL_CONFIG,
]);

export const selectSettingsSelector = createSelector(
  [selectSettingsState],
  (setting) => (setting.settings || []).filter(
    (item: Setting) => !SETTINGS_MANAGED_ON_DEDICATED_PAGES.has(item.setting_key as string)
  )
);

export const selectSettingLoading = createSelector(
  [selectSettingsState],
  (setting) => setting.loading
);

export const selectCurrentSetting = createSelector(
  [selectSettingsState],
  (setting) => setting.currentSetting
);

export const selectSettingsByCategory = (category: string) => createSelector(
  [selectSettingsSelector],
  (settings) => settings.filter((setting: Setting) => setting.category === category)
);

export const selectPageContent = createSelector(
  [selectSettingsState],
  (setting) => ({
    pageContent: merge({}, defaultContent, setting.settings?.find((setting: Setting) => setting.setting_key === SettingKey.PAGE_CONTENT)?.setting_value as unknown as ContentModel || {}),
    loading: setting.loading
  })
);

export const selectMaintenanceMode = createSelector(
  [selectSettingsState],
  (setting) => setting.settings?.find((setting: Setting) => setting.setting_key === SettingKey.MAINTENANCE_MODE)?.setting_value as boolean || false
);

export const selectEnableErrorAlerts = createSelector(
  [selectSettingsState],
  (setting) => !!setting.settings?.find((item: Setting) => item.setting_key === SettingKey.ENABLE_ERROR_ALERTS)?.setting_value || false
);

export const selectBannerModalConfig = createSelector(
  [selectSettingsState],
  (setting) => setting.settings?.find((item: Setting) => item.setting_key === SettingKey.BANNER_MODAL_CONFIG)?.setting_value as Partial<BannerModalConfig> | undefined
);

export const selectVolcanoBannerModalConfig = createSelector(
  [selectSettingsState],
  (setting) => setting.settings?.find((item: Setting) => item.setting_key === SettingKey.VOLCANO_BANNER_MODAL_CONFIG)?.setting_value as Partial<VolcanoBannerModalConfig> | undefined
);